import { DocumentFile, PostDocumentFileBody } from "./types";

export type UserRight = (typeof userRights)[number];
export const userRights = ["admin", "manager", "secretary", "member"] as const;

interface FunctionaryPerson {
  firstName: string;
  id: string;
  lastName: string;
  city: string;
  email: string;
  phone: string;
  mobile: string;
  picture: string;
  street: string;
  zip: string;
}

export interface Person {
  id: string | null;
  picture: string | null;
  name: string | null;
  lastName: string | null;
  email: string;
  phone?: string | undefined;
  mobile?: string | undefined;
  street: string;
  zip: string;
  city: string;
  companyName: string | null;
  roles: string[] | null;
  website?: string | undefined;
}

export interface ChapterFunctionary {
  id: string;
  company: string;
  person: FunctionaryPerson;
  isChapterChairman: boolean;
  isChapterChairmanDeputy: boolean;
  roles: string[];
}

export interface IamUser {
  id: string;
  name: string | null;
  email: string | null;
}

export interface Functionary {
  personId: number;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
}

export interface Role {
  id: string;
  name: string;
  rank: number;
}

export interface Company {
  id: number;
  name: string;
  email?: string;
  website?: string;
  phone?: string;
  street?: string;
  zip?: string;
  city?: string;
}

export interface Location {
  id: string;
  name: string;
}

export interface FunctionaryV2 {
  id: number;
  salutation?: string;
  first_name: string;
  last_name: string;
  picture?: string;
  chapter?: Location;
  district?: Location;
  area?: Location;
  company?: Company;
  roles: Role[];
}

export interface OrganizationChart {
  president: FunctionaryV2 | undefined;
  country_committee: FunctionaryV2[];
  district_committee: FunctionaryV2[];
  area_committee: FunctionaryV2[];
  chapters: number;
  members: number;
}

export interface UserManagmentItem {
  iamUser: IamUser | null;
  person: Functionary | null;
  permission: UserRight;
}

export interface UserPermission {
  userId: string;
  personId: string | null;
  permission: UserRight;
}

export interface ISelectOption {
  value: string | null;
  label: string;
  isDisabled?: boolean;
}

export interface Member {
  city: string;
  company: string;
  email: string;
  legalRepresentative: { firstName: string; lastName: string };
  phone?: string;
  mobile?: string;
  street: string;
  zip: string;
  website?: string;
}

export interface Chapter {
  id: number;
  name: string;
  taxCode: string | null;
  vatNumber: string | null;
  area: {
    id: number;
    name: string;
    district: {
      id: number;
      name: string;
    };
  };
}

export interface DistrictMember {
  id: number;
  person: FunctionaryPerson;
  company: string;
  roles: string[];
  isChapterChairman: boolean;
  isChapterChairmanDeputy: boolean;
  isPresident: boolean;
  isDirector: boolean;
  isDistrictChairman: boolean;
  isAreaChairman: boolean;
  isSuedtirolerGastwirtinnenDistrictRepresentative: boolean;
}

export interface EventType {
  id: number;
  title: string;
  description: string | null;
  location: string | null;
  from: string;
  to: string;
  category: string;
  signUpLink: string | null;
}

export interface ModalType {
  isOpen: boolean;
  data: EventType[] | undefined;
}

export interface DeleteDocumentModalType {
  isOpen: boolean;
  file: DocumentFile | undefined;
}

export interface UpsertDocumentModalType {
  body: PostDocumentFileBody;
  file: File;
}
